import React, { useState,useEffect } from "react";
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Card, CardBody, Table,Row,Col,UncontrolledTooltip, FormGroup, Form } from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import Select from "../../../../../components/Common/custom-select";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik} from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchEmployeeDropdownAutoList,
  fetchShiftLate,
  saveShiftLate,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FiCalendar, FiEye, FiRepeat, FiSave, FiSearch } from "react-icons/fi";
import CustomDatePicker from "common/CustomDatePicker";
import CustomSelect from "../../../../../components/Common/custom-select";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const TimeDeductionShiftLate = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    shiftLateProcess,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    shiftLateProcess: state.AttendanceTimeDeductionsReducer?.shiftLateProcess,

    loading: state.AttendanceTimeDeductionsReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.AttendanceTimeDeductionsReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.AttendanceTimeDeductionsReducer?.success
  })); 
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchShiftLate(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchShiftLate(authDetails?.unit_id));
      formik.resetForm()
    }
  }, [authDetails,success,dispatch]);

  const validationSchema = Yup.object({
    // department:Yup.object().required("Department is required"),
    fromDate: Yup.date().nullable()
      .required("From Date is required"),

    toDate: Yup.date().nullable()
      .required("To Date is required")
      .test(
        "is-before-fromDate",
        "To Date cannot be before From Date",
        function (value) {
          const { fromDate } = this.parent;
          return !fromDate || !value || new Date(value) >= new Date(fromDate);
        }
      )
      .test(
        "is-within-one-month",
        "To Date cannot be more than 1 month after From Date",
        function (value) {
          const { fromDate } = this.parent;
          if (!fromDate || !value) return true;
          const maxDate = new Date(fromDate);
          maxDate.setMonth(maxDate.getMonth() + 1);
          return new Date(value) <= maxDate;
        }
      ),
  });

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      fromDate: "",
      toDate: "",
      employee: "",
    },
    validationSchema,
    onSubmit: (values) => {
      // console.log('shift late > ', values);
      const formData = new FormData();
      formData.append(
        "cat_id",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "dept_id",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "design_id",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append(
        "emp_id",
        values.employee && values.employee.length ? values.employee.map(item => item.value).join(",") : '0'
      );

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(saveShiftLate(formData));
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  const modalColumns = [
    { Header: "S.No", accessor: "sno" },
    { Header: "Employee", accessor: "employee" },
    { Header: "Date", accessor: "date" },
    { Header: "Timings", accessor: "timings" },
    { Header: "Type", accessor: "type" },
  ];

  const columns = [
    { Header: "S.No", Cell: ({ row }) => shiftLateProcess.length - row.index, className: "serial-no text-center" },
    { Header: "Processed On", accessor: "last_run_date" },
    { Header: "From Date", accessor: "from_date" },
    { Header: "To Date", accessor: "to_date" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Employees", accessor: "employees" },
    { Header: "Processed By", accessor: "processed_by" },
  ];
    

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Time Deductions" breadcrumbItem="Late Process" />
          {canCreate && (
            <Card>
              <CardBody>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="category">Category</Label>
                        <CustomSelect
                          id="category"
                          name="category"
                          options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                          value={formik.values.category || null}
                          onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                          onBlur={formik.handleBlur}
                          className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                          isMulti
                        />
                        {formik.touched.category && formik.errors.category && (
                          <div className="text-danger">{formik.errors.category}</div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="department">Department</Label>
                        <CustomSelect
                          id="department"
                          name="department"
                          options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                          value={formik.values.department || null}  // Store full object
                          onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                          onBlur={formik.handleBlur}
                          className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                          isMulti
                        />
                        {formik.touched.department && formik.errors.department && (
                          <div className="text-danger">{formik.errors.department}</div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="designation">Designation</Label>
                        <CustomSelect
                          id="designation"
                          name="designation"
                          options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                          value={formik.values.designation || null}  // Store full object
                          onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                          onBlur={formik.handleBlur}
                          className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                          isMulti
                        />
                        {formik.touched.designation && formik.errors.designation && (
                          <div className="text-danger">{formik.errors.designation}</div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* Employee Selection */}
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="employee">Employee</Label>
                        <CustomSelect
                          id="employee"
                          name="employee"
                          options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                          value={formik.values.employee || null}  // Store full object
                          onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                          onBlur={formik.handleBlur}
                          className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                          isMulti
                        />
                        {formik.touched.employee && formik.errors.employee && (
                          <div className="text-danger">{formik.errors.employee}</div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* From Date */}
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                        <CustomDatePicker
                          name="fromDate"
                          value={formik.values.fromDate}
                          onChange={(date) => formik.setFieldValue("fromDate", date)}
                          onBlur={formik.handleBlur}
                          disableFuture={true}
                          className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                        />
                        {formik.touched.fromDate && formik.errors.fromDate && (
                          <div className="text-danger">{formik.errors.fromDate}</div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* To Date */}
                    <Col md={3} sm={12} className="mb-3">
                      <FormGroup>
                        <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                        <CustomDatePicker
                          name="toDate"
                          value={formik.values.toDate}
                          onChange={(date) => formik.setFieldValue("toDate", date)}
                          onBlur={formik.handleBlur}
                          disableFuture={true}
                          className={`form-control ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                        />
                        {formik.touched.toDate && formik.errors.toDate && (
                          <div className="text-danger">{formik.errors.toDate}</div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* Buttons */}
                    <Col md={6} sm={12} className="d-flex align-items-center justify-content-end mob-center">
                      <Button type="submit" className="btn button-save me-2" >
                        <i className="fas fa-spinner me-1 " /> Process
                      </Button>
                      {/* <Button type="button" color="primary" className="me-2">
                      <FiSave/>Submit
                    </Button> */}
                      <Button type="button" onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                      </Button>
                    </Col>
                    <Row className="mb-3">
                      <Col className="text-center">
                        <p className="text-danger fw-bold">
                          ⚠️ Important: Please clear all Absent List entries and resolve Discrepancies before continuing.
                        </p>
                      </Col>
                    </Row>
                  </Row>

                </Form>
              </CardBody>
            </Card>
          )}

          <Card>
            <CardBody>
              <TableContainer columns={columns} data={shiftLateProcess && shiftLateProcess.length > 0 ? shiftLateProcess : []} isGlobalFilter={true} customPageSize={10} />
            </CardBody>
          </Card>
        </Container>

        <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
          <ModalHeader toggle={() => setModal(false)}>Punch Orders</ModalHeader>
          <ModalBody>
            <TableContainer columns={modalColumns} data={modalData} isGlobalFilter={true} customPageSize={10} />
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default TimeDeductionShiftLate;
